<template>
  <!-- Loading -->
  <div v-if="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des types de service...</p>
  </div>

  <div v-else class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-gear-fill fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Types de service</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique" @click="creation">
        <i class="bi bi-plus-circle"></i>
      </button>
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-md-4">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Nom du type de service..."
            class="form-control form-control-clinique"
          />
        </div>

        <div class="col-md-3">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label fw-semibold">Statut</label>
          <select v-model="filterStatus" class="form-select form-select-clinique">
            <option value="">Tous</option>
            <option value="1">Activé</option>
            <option value="0">Désactivé</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tableau -->
    <div class="card shadow-sm rounded card-clinique">
      <div class="table-responsive">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Description</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(type, index) in filteredTypes" :key="type.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ type.nom }}</td>
              <td>{{ type.description}}</td>
              <td>
                <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-danger']">
                  {{ type.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" @click="modifier(type.id)">Modifier</a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" @click="supprimer(type.id)">Supprimer</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>

            <tr v-if="types.length === 0">
              <td colspan="5" class="text-center py-3">Aucun type de service trouvé</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>
<script>
import api from '@/api';

export default {
  name: 'ListeTypeService',
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,

      types: [],
      totalItems: 0,
      currentPage: 1,

      searchQuery: '',
      itemsperpage: 10,
      itemsPerPageT: [5, 10, 20, 50],
      filterStatus: ''
    };
  },

  computed: {
    filteredTypes() {
      let result = this.types;

      if (this.searchQuery) {
        result = result.filter(t =>
          t.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      if (this.filterStatus !== '') {
        const status = this.filterStatus === '1';
        result = result.filter(t => t.isEnabled === status);
      }

      return result;
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },

  methods: {
    creation() {
      this.$router.push({ name: 'create_type_service' });
    },

    async getTypes() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }

      try {
        const response = await api.getItems('type_services', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          search: this.searchQuery
        });

        const { data, meta } = response.data;
        this.types = data;
        this.totalItems = meta?.total_records || data.length;
      } catch (e) {
        console.error('Erreur chargement types service', e);
      } finally {
        this.isLoading = false;
      }
    },

    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getTypes();
      }
    },

    modifier(id) {
      this.$router.push({ name: 'edit_type_service', params: { id } });
    },

    async supprimer(id) {
      if (!confirm('Supprimer ce type de service ?')) return;

      try {
        this.isLoading = true;
        await api.deleteItem('type_services', id);
        this.getTypes();
      } catch (e) {
        alert('Erreur lors de la suppression');
      } finally {
        this.isLoading = false;
      }
    }
  },

  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getTypes();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getTypes();
    }
  },

  created() {
    this.getTypes();
  }
};
</script>
<style scoped>

.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique { background: #f8fafd; border-radius: 12px; border: none; }
.form-control-clinique, .form-select-clinique { border-radius: 10px; border: 1px solid #d1e3f0; padding: 8px 12px; transition: all 0.3s ease; }
.form-control-clinique:focus, .form-select-clinique:focus { box-shadow: 0 0 6px #0d6efd33; border-color: #0d6efd; }
.btn-clinique { background: linear-gradient(90deg, #0d6efd, #6610f2); border: none; color: #fff; border-radius: 10px; transition: all 0.3s ease; }
.btn-clinique:hover { box-shadow: 0 5px 15px rgba(0,0,0,0.2); transform: translateY(-2px); }
.modern-table-clinique thead { background: linear-gradient(90deg, #8fd3f4, #0d6efd); color: #fff; font-weight: 600; }
.modern-table-clinique tbody tr:hover { background-color: #e1f0ff; cursor: pointer; transition: all 0.3s ease; }
.badge { font-size: 0.85rem; padding: 0.4em 0.7em; border-radius: 12px; }
.pagination-modern .page-link { border-radius: 50% !important; margin: 0 4px; min-width: 38px; min-height: 38px; display: flex; align-items: center; justify-content: center; color: #0d6efd; border: 1px solid #dee2e6; }
.pagination-modern .page-item.active .page-link { background-color: #0d6efd; color: #fff; border-color: #0d6efd; }
.pagination-modern .page-link:hover { background-color: #d1e7ff; transition: all 0.3s ease; }
</style>
